import { createSlice } from '@reduxjs/toolkit';

// utils
import axios from 'utils/axios';
import { ACTIONS } from 'utils/constants';
import { validateDates } from 'utils/formatTime';

//
import API from 'restApi';
import { dispatch, store } from '../store';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  actor: null,
  actors: [],
  usersActor: [],
  navig: {
    total: 0,
    nav_position: 0,
    nb_item_per_page: 10
  },

  filters: {
    address: '',
    actorcode: '',
    postalcode: '',
    town: '',
    exclusivity: false,
    actortype: '',
    actorname: '',
    actorfirstname: '',
    visibility: '',
    lastUpdateFrom: null,
    lastUpdateTo: null,
    sort_column_name: 'actorname',
    sort_type: 'ASC'
  },

};

const slice = createSlice({
  name: 'actors',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;

    },

    // GET actors
    getActorsSuccess(state, action) {
      const { actors, navig } = action.payload;
      state.isLoading = false;
      state.actors = actors;
      state.error = null;
      state.navig = navig;
    },

    getUsersForActorSuccess(state, action) {
      const { data } = action.payload;
      state.usersActor = data;
      state.isLoading = false;
      state.error = null;
    },

    //  SORT & FILTER actors
    sortByActors(state, action) {
      state.sortBy = action.payload;
    },
    sortActors(state, action) {
      state.filters = { ...state.filters, sort_type: action.payload.orderColumn, sort_column_name: action.payload.sortColumn };
    },
    paginationActors(state, action) {
      state.navig = { ...state.navig, nav_position: action.payload };
    },
    filterActors(state, action) {
      state.filters = action.payload;
    },
    resetActors(state) {
      state.actors = initialState.actors;
      state.navig = initialState.navig;
      state.filters = initialState.filters;
    },
    resetActor(state) {
      state.actor = initialState.actor;
    },

    // GET Users
    getActorSuccess(state, action) {
      const { actor } = action.payload;
      state.isLoading = false;
      state.actor = actor;
      state.error = null;
    },

  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  paginationActors,
  filterActors,
  resetActors,
  resetActor,
  hasError,
  sortActors
} = slice.actions;

// ----------------------------------------------------------------------

export function getActors() {
  const { actor: { filters, navig }, all: { config } } = store.getState();
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const start = new Date(filters.lastUpdateFrom).getTime();
      const end = new Date(filters.lastUpdateTo).getTime();
      const errors = validateDates({ start, end });
      if (Object.keys(errors).length > 0)
        throw new Error('', { cause: [errors] });

      // Fixer lastUpdateTo à 23h59
      const lastUpdateTo = filters.lastUpdateTo ? new Date(new Date(filters.lastUpdateTo).setHours(23, 59, 59)).toISOString() : null;

      const criteres = { ...filters, actortype: filters.actortype.code, visibility: filters.visibility.code, exclusivity: filters.exclusivity ? 'O' : null, lastUpdateTo };

      const response = await axios.post(API.path, {
        criteres,
        navig: {
          total: navig.total,
          nav_position: navig.nav_position,
          nb_item_per_page: config?.nbItemPerPage
        },
        action: ACTIONS.SEARCHACTOR
      });

      const { data } = response;
      dispatch(slice.actions.getActorsSuccess(data));
      if (data.statut === "OK")
      {
        if (data.actors.length === 0)
          throw new Error('NO_RESULTS');
      } else{
        throw new Error(data.reason);
      }


    } catch (error) {
      dispatch(slice.actions.hasError(error?.cause?.length > 0 ? error.cause[0] : error));
    }
  };
}
export function getActor({ actorcode }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.LOADACTOR,
        actorcode
      });
      const { data: { data } } = response;

      dispatch(slice.actions.getActorSuccess({ actor: data }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getUsersForActor({ actorcode }) {
  return async () => {

    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        actorcode,
        action: ACTIONS.GETUSERSFORACTOR
      });

      const { data } = response;
      dispatch(slice.actions.getUsersForActorSuccess(data));

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function testActorCodeIsValid(actorcode) {
  const { data: { isValid } } = await axios.post(API.path, {
    action: ACTIONS.ISACTORCODEVALID,
    actorcode
  });
  return isValid;
}



